<template>
  <div class="sidebar">
    <div
      v-if="isPanelOpen"
      class="sidebarBackdrop"
      @click="closeSidebarPanel"
    ></div>
    <transition name="slide">
      <div v-if="isPanelOpen" class="sidebarPanel">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { replaceStore, replaceMutations } from '@state/helpers'

export default {
  computed: {
    isPanelOpen() {
      return replaceStore.isNavOpen
    },
  },
  methods: {
    closeSidebarPanel() {
      // this.$parent.fadeStage()
      setTimeout(() => {
        replaceMutations.toggleNav()
      }, 200)
    },
  },
}
</script>

<style lang="scss">
@import '@design';

.slide-enter-active,
.slide-leave-active {
  transition: transform 1s ease;
}

.slide-enter,
.slide-leave-to {
  transition: all 1s;
  transform: translateX(-200%);
}

.sidebarPanel {
  position: relative;
  z-index: 20;
}

.sidebarBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  cursor: pointer;
}
</style>
